import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { locationCountryField } from './common/locationFields';
import { descriptionField } from './common/sharedFields';
import {
  currencyField,
  currencyQuantityField,
} from './common/expenditureFields';

export const lobbyingMetadata = {
  displayName: msg({
    message: 'Lobbying',
    context: 'Activity data schema name for lobbying',
  }),
  fields: {
    ...coreFields,
    contribution_kind: {
      displayName: msg({
        message: 'Contribution kind',
        context: 'The display name for contribution kind field',
      }),
    },
    currency: currencyField,
    currency_quantity: {
      ...currencyQuantityField,
      externalDescription: msg({
        message: 'The total amount of money spent (or estimated) on lobbying.',
        context: 'Currency quantity',
      }),
    },
    description: descriptionField,
    estimation_method: {
      displayName: msg({
        message: 'Estimation method',
        context: 'The display name for estimation method field',
      }),
    },
    expense_kind: {
      displayName: msg({
        message: 'Expense kind',
        context: 'The display name for expense kind field',
      }),
    },
    location_country: locationCountryField,
    recipient: {
      displayName: msg({
        message: 'Recipient',
        context: 'The display name for recipient field',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
